/**
 * Logo Marquee — pause when autoplay off / reduced motion
 */
(function () {
  function initMarquee(root) {
    if (!root || root.dataset.lmInit === 'true') return;
    root.dataset.lmInit = 'true';

    var track = root.querySelector('[data-logo-marquee-track]');
    if (!track) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!autoplay || reduceMotion) {
      track.classList.add('logo-marquee__track--paused');
      track.classList.remove('logo-marquee__track--animate');
    } else {
      track.classList.add('logo-marquee__track--animate');
      track.classList.remove('logo-marquee__track--paused');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-logo-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-logo-marquee]');
    if (root) {
      root.dataset.lmInit = 'false';
      initMarquee(root);
    }
  });
})();
